module.exports = __webpack_public_path__ + "img/avatar4.023d0fca.png";